module.exports = __webpack_public_path__ + "img/ProfilePicture.1981a8e3.jpg";